<template>
    <section class="main">
        <transition name="fade" mode="out-in">
            <router-view :key="key"></router-view>
        </transition>
    </section>
</template>

<script>
    export default {
        name: 'AppMain',
        computed: {
            key() {
                return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
            }
        },
        created() {
            // console.log(this.$route)
        }
    }
</script>



// WEBPACK FOOTER //
// AppMain.vue?d8e8c8bc